import { useQuery } from "@tanstack/react-query"

import { fetchActiveOrder } from "@/actions/queries/order"

export const activeOrderQueryKey = ["active-order"]

export function useActiveOrderQuery() {
  return useQuery({
    queryKey: activeOrderQueryKey,
    queryFn: () => fetchActiveOrder(),
  })
}
